import { createStore } from "vuex";

interface appState {
  isLoading: boolean;
  waitList: number;
  ToList: number;
  simpleInfo: simpleInfo;
  staffInfo: { [key: string]: any };
  isLogin: boolean;
  StaffId: number;
}
interface simpleInfo {
  CompanyName?: string;
  DepartmentName?: string;
  PhotoUrl?: string;
  StaffName?: string;
  PostType?: string;
  PositionName?: string;
  IsCreate?: number;
  StaffId?: number;
}

export default createStore({
  state: (): appState => ({
    isLoading: false,
    waitList: 0, //待办数量
    ToList: 0, //抄送数量
    simpleInfo: {
      CompanyName: "",
      DepartmentName: "",
      PhotoUrl: "",
      StaffName: "",
      PostType: "",
      PositionName: "",
      IsCreate: 0,
      StaffId: 0,
    },
    staffInfo: {},
    isLogin: false,
    StaffId: 0,
  }),
  mutations: {
    setLoading(state, isLoading) {
      state.isLoading = isLoading;
    },
    setWaitList(state, value) {
      state.waitList = value;
    },
    setToList(state, value) {
      state.ToList = value;
    },
    setSimpleInfo(state, value) {
      state.simpleInfo = value;
    },
    setStaffInfo(state, value) {
      state.simpleInfo = value;
    },
    setLogin(state, value) {
      state.isLogin = value;
    },
    setStaffId(state, value) {
      state.StaffId = value;
    },
  },
  getters: {
    getLoadingStatus(state): boolean {
      return state.isLoading;
    },
    getWaitList(state): number {
      return state.waitList;
    },
    getToList(state): number {
      return state.ToList;
    },
    getPersonImg(state) {
      return state.simpleInfo.PhotoUrl || "";
    },
    getSimpleInfo(state): simpleInfo {
      return state.simpleInfo;
    },
    getLogin(state): boolean {
      return state.isLogin;
    },
    getStaffId(state, value) {
      return state.StaffId;
    },
  },
  actions: {
    setLoading(context, isLoading) {
      context.commit("setLoading", isLoading);
    },
    setWaitList(context, value) {
      context.commit("setWaitList", value);
    },
    setSimpleInfo(context, value) {
      context.commit("setSimpleInfo", value);
    },
    setStaffInfo(context, value) {
      context.commit("setStaffInfo", value);
    },
    setLogin(context, value) {
      context.commit("setLogin", value);
    },
    setStaffId(context, value) {
      context.commit("setStaffId", value);
    },
  },
  modules: {},
});
